import type { UserInfo } from '@optimizely/react-sdk/dist/utils';
import type { OptimizelyDataFile } from '../optimizely.types';

import { useEffect } from 'react';
import { getOptimizelyReactSDKClient } from '../optimizelyClientInstance';
import {
    forceExperiments,
    OptimizelyOverrides,
    writeOverridesToCookies
} from '../optimizelyOverrides';

const halfASecInMs = 500;

type PageProps = {
    optimizelyUserInfo: UserInfo;
    optimizelyDatafile?: OptimizelyDataFile;
    optimizelyOverrides?: OptimizelyOverrides;
};

const useOptimizelyProviderProps = ({
    optimizelyDatafile,
    optimizelyOverrides,
    optimizelyUserInfo
}: PageProps) => {
    const isServerSide = typeof window === 'undefined';
    const anonId = optimizelyUserInfo.id;
    useEffect(() => {
        if (optimizelyOverrides) {
            writeOverridesToCookies(optimizelyOverrides);
        }
    }, [optimizelyOverrides]);

    const optimizely = getOptimizelyReactSDKClient(optimizelyDatafile);

    if (anonId && optimizely) {
        forceExperiments(optimizelyOverrides?.experiments, anonId, optimizely);
    }

    const enabledFeatures = optimizely?.getEnabledFeatures(
        anonId || undefined,
        optimizelyOverrides?.experiments
    );

    if (enabledFeatures?.length && typeof window !== 'undefined') {
        window.newrelic?.setCustomAttribute(
            'enabledOptimizelyFeatures',
            enabledFeatures.join('|')
        );
    }

    const optimizelyProviderProps = {
        timeout: halfASecInMs,
        user: optimizelyUserInfo,
        isServerSide,
        optimizely
    };

    return {
        optimizelyProviderProps,
        optimizelyOverrides,
        optimizelyDatafile
    };
};

export default useOptimizelyProviderProps;
